import React, { useMemo } from 'react';
import { Card, Image, Tooltip } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import DefaultImage from './default-image.png';
import truncateText from '../../../../../../../utils/truncateText';
import './styles.css';

const CollectionCard = props => {
  const { collection, onClick } = props;

  const images = useMemo(() => {
    const productThumbnails = [];
    const vendorThumbnails = [];
    const attachmentThumbnails = [];
    collection?.collectionProducts?.map(product => {
      if (product.product?.images?.[0]) {
        productThumbnails.push(product.product.images?.[0].sourceUrl);
      }
    });
    collection?.collectionVendorItems?.map(item => {
      if (item?.item.images?.[0]) {
        vendorThumbnails.push(item?.item.images?.[0].sourceUrl);
      }
    });
    collection?.collectionAttachments?.map(item => {
      if (item?.url) {
        attachmentThumbnails.push(item.url);
      }
    });

    const mergedImages = [...productThumbnails, ...vendorThumbnails, ...attachmentThumbnails].slice(0, 4);

    return mergedImages;
  }, [collection]);

  return (
    <Card className="clients-v2-collection--card" onClick={onClick} hoverable>
      <div className="clients-v2-collection--card-header">
        <div>
          <span className="clients-v2-collection--card-header-title">
            <Tooltip title={collection.name}>
              {truncateText(collection.name, 22, { cutWords: true })}
            </Tooltip>
          </span>

          <span className="clients-v2-collection--card-header-subtitle">
            {collection.isShared ? 'Shared with client' : ''}
          </span>
        </div>

        <RightOutlined />
      </div>

      <div className="clients-v2-collection--card-body">
        {images.map((image, index) => (
          <Image
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            src={image}
            width={110}
            height={110}
            preview={false}
            fallback={DefaultImage}
          />
        ))}
      </div>
    </Card>
  );
};

export default CollectionCard;
